import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1RecommendationTemplateList: build.query<
      ApiAdminV1RecommendationTemplateListApiResponse,
      ApiAdminV1RecommendationTemplateListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/recommendation-template/`,
        params: {
          id: queryArg.id,
          name: queryArg.name,
          sort_order: queryArg.sortOrder,
          target: queryArg.target,
          type_of: queryArg.typeOf,
        },
      }),
    }),
    apiAdminV1RecommendationTemplateCreate: build.mutation<
      ApiAdminV1RecommendationTemplateCreateApiResponse,
      ApiAdminV1RecommendationTemplateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/recommendation-template/`,
        method: "POST",
        body: queryArg.recommendationTemplate,
      }),
    }),
    apiAdminV1RecommendationTemplateRetrieve: build.query<
      ApiAdminV1RecommendationTemplateRetrieveApiResponse,
      ApiAdminV1RecommendationTemplateRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/recommendation-template/${queryArg.id}/`,
      }),
    }),
    apiAdminV1RecommendationTemplateUpdate: build.mutation<
      ApiAdminV1RecommendationTemplateUpdateApiResponse,
      ApiAdminV1RecommendationTemplateUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/recommendation-template/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.recommendationTemplate,
      }),
    }),
    apiAdminV1RecommendationTemplatePartialUpdate: build.mutation<
      ApiAdminV1RecommendationTemplatePartialUpdateApiResponse,
      ApiAdminV1RecommendationTemplatePartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/recommendation-template/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedRecommendationTemplate,
      }),
    }),
    apiAdminV1RecommendationTemplateDestroy: build.mutation<
      ApiAdminV1RecommendationTemplateDestroyApiResponse,
      ApiAdminV1RecommendationTemplateDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/recommendation-template/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1RecommendationTemplateListApiResponse =
  /** status 200  */ RecommendationTemplateRead[];
export type ApiAdminV1RecommendationTemplateListApiArg = {
  id?: number;
  name?: string;
  sortOrder?: number;
  target?: number;
  typeOf?: number;
};
export type ApiAdminV1RecommendationTemplateCreateApiResponse =
  /** status 201  */ RecommendationTemplateRead;
export type ApiAdminV1RecommendationTemplateCreateApiArg = {
  recommendationTemplate: RecommendationTemplate;
};
export type ApiAdminV1RecommendationTemplateRetrieveApiResponse =
  /** status 200  */ RecommendationTemplateRead;
export type ApiAdminV1RecommendationTemplateRetrieveApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
};
export type ApiAdminV1RecommendationTemplateUpdateApiResponse =
  /** status 200  */ RecommendationTemplateRead;
export type ApiAdminV1RecommendationTemplateUpdateApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
  recommendationTemplate: RecommendationTemplate;
};
export type ApiAdminV1RecommendationTemplatePartialUpdateApiResponse =
  /** status 200  */ RecommendationTemplateRead;
export type ApiAdminV1RecommendationTemplatePartialUpdateApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
  patchedRecommendationTemplate: PatchedRecommendationTemplate;
};
export type ApiAdminV1RecommendationTemplateDestroyApiResponse = unknown;
export type ApiAdminV1RecommendationTemplateDestroyApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
};
export type RecommendationTemplateStatusEnum =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 9
  | 11
  | 12
  | 99;
export type TypeOf3B0Enum = 1 | 2 | 3 | 4;
export type TargetEnum = 1 | 2;
export type RecommendationTemplate = {
  name: string;
  status?: RecommendationTemplateStatusEnum;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
};
export type RecommendationTemplateRead = {
  id: number;
  name: string;
  status?: RecommendationTemplateStatusEnum;
  status_text: string;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
  created_at: string;
  updated_at: string;
  in_use: boolean;
};
export type PatchedRecommendationTemplate = {
  name?: string;
  status?: RecommendationTemplateStatusEnum;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
};
export type PatchedRecommendationTemplateRead = {
  id?: number;
  name?: string;
  status?: RecommendationTemplateStatusEnum;
  status_text?: string;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
  created_at?: string;
  updated_at?: string;
  in_use?: boolean;
};
export const {
  useApiAdminV1RecommendationTemplateListQuery,
  useApiAdminV1RecommendationTemplateCreateMutation,
  useApiAdminV1RecommendationTemplateRetrieveQuery,
  useApiAdminV1RecommendationTemplateUpdateMutation,
  useApiAdminV1RecommendationTemplatePartialUpdateMutation,
  useApiAdminV1RecommendationTemplateDestroyMutation,
} = injectedRtkApi;
